import { useRef, useEffect } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";
import "swiper/css/navigation";
import tImg1 from "../../images/testimonial/sa-tas05.png";
import tImg2 from "../../images/testimonial/sa-tas01.png";

import icon1 from "../../images/testimonial/tes-logo02.png";
import icon2 from "../../images/testimonial/tes-logo01.png";

import quote from "../../images/icon/quta.png";
import hicon from "../../images/icon/like-icon.svg";

const testimonial = [
  {
    id: "01",
    tImg: tImg1,
    Des: "Ao longo destes últimos 5 anos tivemos a sorte de ter esta parceria tão próxima e produtiva como a que temos com a Somar Cloud. Sempre demonstram competência e comprometimento com o cliente. Ter uma relação de alto nível técnico e comercial, é essencial para investir de forma inteligente em TI. Trabalhamos com Equipamentos Mikrotik para montar uma estrutura VPN entre nossa central e nossos clientes de portaria remota. O Suporte dado pela equipe da Somar Cloud faz toda a diferença para nós.",
    Name: "Primeiro Alerta",
    sub: "Tecnologia em Segurança LTDA.",
    country: "São Paulo, SP",
  },
  {
    id: "02",
    tImg: tImg2,
    Des: "Após a nossa migração para Somar Cloud, utilizando o Microsoft Exchange, ganhamos um ambiente estável, com suporte rápido e qualificado quando foi necessário. Recebíamos muitos spams e com essa solução a quantidade praticamente caiu a zero, tornando a ferramenta (e-mail) mais produtiva pois agora os colaboradores não perdem tempo verificando os e-mails válidos e os spams.",
    Name: "Rodrigo Kerssner",
    sub: "Gerente de TI na Incorfast",
  },
];

const Testimonial = (props) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section className={`testimonial o-hidden pb-140 ${props.tClass}`}>
      <div className="container">
        <div className="sa-tes_top pos-rel mb-60">
          <div className="sec-title--two">
            <Fade
              direction="down"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <div
                  className="sub-title wow fadeInDown"
                  data-wow-duration="600ms"
                >
                  <img src={hicon} alt="" />
                  99% de satisfação dos clientes
                </div>
              </div>
            </Fade>
            <Fade
              direction="up"
              triggerOnce={"false"}
              duration={1200}
              delay={9}
            >
              <div>
                <h2
                  className="title wow fadeInDown"
                  data-wow-delay="150ms"
                  data-wow-duration="600ms"
                >
                  Depoimentos que falam por si
                </h2>
              </div>
            </Fade>
          </div>
          <div className="sa-tes_button">
            <div className="sa-swiper-btn swiper-button-prev" ref={prevRef}>
              <i className="fal fa-angle-left"></i>
            </div>
            <div
              className="sa-swiper-btn active swiper-button-next"
              ref={nextRef}
            >
              <i className="fal fa-angle-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="sa-testimonial-slider-inner">
        <div className="sa-testimonial-slider sa-testimonial-slider-wide">
          <div className="swiper-wrapper">
            <Swiper
              // install Swiper modules
              modules={[Navigation]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              speed={1800}
              parallax={true}
              ref={swiperRef}
              centeredSlides={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
              }}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
            >
              {testimonial.map((testimonial, tsm) => (
                <SwiperSlide key={tsm}>
                  <div className="sa-testimonial-item-wide">
                    <div className="xb-item--inner-wide">
                      <div className="testimonial-content-wide">
                        <div className="xb-item--quta">
                          <img src={quote} alt="" />
                        </div>
                        <p className="xb-item--content-wide">
                          "{testimonial.Des}"
                        </p>
                      </div>
                      <div className="testimonial-author-wide">
                        <div className="xb-item--avatar">
                          <img src={testimonial.tImg} alt="" />
                        </div>
                        <div className="xb-item--author">
                          <h3 className="xb-item--name">{testimonial.Name}</h3>
                          <span className="xb-item--desig">
                            {testimonial.sub}
                          </span>
                          {/* <div className="xb-item--logo">
                            <img src={testimonial.logo} alt="" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
